import React from 'react';
import BzmIcon from '../../../../../components/icons/BzmIcon';
import styles from './EmptyGroupPlaceholder.module.css';

interface EmptyGroupPlaceholderProps {
  onAssignMockService: () => void;
  disableAdd: boolean;
}

const EmptyGroupPlaceholder = ({ disableAdd, onAssignMockService }: EmptyGroupPlaceholderProps) => {
  return (
    <div>
      <div className={'d-flex justify-content-center align-items-center'}>
        <div className="text-center mt-10 pb-8">
          <BzmIcon variant={'icon-bzm-info'} className={styles.icon} />
          <h4 className="font-size-xlg font-weight-semi-bold mt-3">Virtual Service Group is Empty</h4>
          <div className="p-2 bd-highlight text-center" style={{ maxWidth: '400px' }}>
            <p>Assign Virtual Services to define the behavior of this Virtual Service Group.</p>
          </div>

          <button
            disabled={disableAdd}
            className={'btn btn-primary ml-4'}
            onClick={() => {
              onAssignMockService();
            }}
          >
            <BzmIcon variant={'icon-bzm-playlist-add'} size={16} className={'pr-2'} />
            <span className={'position-relative'} style={{ bottom: 2 }}>
              Assign Virtual Service
            </span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default EmptyGroupPlaceholder;
